const COLLECTION_MESSAGES = {
  COLLECTION_NOW: 'Available now',
  COLLECTION_TODAY: 'Available today',
  COLLECTION_TOMORROW: 'Available tomorrow',
  COLLECTION_AVAILABLE: 'Available'
}

const DELIVERY_MESSAGES = {
  DELIVERY_TODAY: 'Get it today',
  DELIVERY_TOMORROW: 'Get it tomorrow',
  DELIVERY_AVAILABLE: 'Available for delivery'
}

const ERROR_MESSAGES = {
  OUT_OF_STOCK: 'Not in stock',
  UNAVAILABLE: 'Not available'
}

const COLLECTION_MAPPINGS = {
  COLLECTION_NOW: COLLECTION_MESSAGES.COLLECTION_NOW,
  COLLECTION_FROM_TODAY_AT_TIME: COLLECTION_MESSAGES.COLLECTION_TODAY,
  COLLECTION_FROM_TOMORROW: COLLECTION_MESSAGES.COLLECTION_TOMORROW,
  COLLECTION_FROM_TOMORROW_AT_TIME: COLLECTION_MESSAGES.COLLECTION_TOMORROW,
  COLLECTION_FROM_DATE: COLLECTION_MESSAGES.COLLECTION_AVAILABLE,

  COLLECTION_PARTIAL_NOW: COLLECTION_MESSAGES.COLLECTION_NOW,
  COLLECTION_PARTIAL_FROM_TODAY_AT_TIME: COLLECTION_MESSAGES.COLLECTION_TODAY,
  COLLECTION_PARTIAL_FROM_TOMORROW: COLLECTION_MESSAGES.COLLECTION_TOMORROW,
  COLLECTION_PARTIAL_FROM_TOMORROW_AT_TIME: COLLECTION_MESSAGES.COLLECTION_TOMORROW,
  COLLECTION_PARTIAL_FROM_DATE: COLLECTION_MESSAGES.COLLECTION_AVAILABLE,

  COLLECTION_OUT_OF_STOCK: ERROR_MESSAGES.OUT_OF_STOCK,
  COLLECTION_OUT_OF_STOCK_TU: ERROR_MESSAGES.OUT_OF_STOCK,
  COLLECTION_NOT_AVAILABLE: ERROR_MESSAGES.UNAVAILABLE
}

const DELIVERY_MAPPINGS = {
  DELIVERY_1_MAN_FROM_TODAY: DELIVERY_MESSAGES.DELIVERY_TODAY,
  DELIVERY_1_MAN_FROM_TOMORROW: DELIVERY_MESSAGES.DELIVERY_TOMORROW,
  DELIVERY_1_MAN_WITHIN_X_DAYS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_1_MAN_WITHIN_X_WEEKS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,

  DELIVERY_2_MAN_FROM_TODAY: DELIVERY_MESSAGES.DELIVERY_TODAY,
  DELIVERY_2_MAN_FROM_TOMORROW: DELIVERY_MESSAGES.DELIVERY_TOMORROW,
  DELIVERY_2_MAN_WITHIN_X_DAYS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_2_MAN_WITHIN_X_WEEKS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_2_MAN_FLEET_NEXT_DAY_OVERRIDE: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,

  DELIVERY_PARTIAL_1_MAN_FROM_TODAY: DELIVERY_MESSAGES.DELIVERY_TODAY,
  DELIVERY_PARTIAL_1_MAN_FROM_TOMORROW: DELIVERY_MESSAGES.DELIVERY_TOMORROW,
  DELIVERY_PARTIAL_1_MAN_WITHIN_X_DAYS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_PARTIAL_1_MAN_WITHIN_X_WEEKS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,

  DELIVERY_PARTIAL_2_MAN_FROM_TODAY: DELIVERY_MESSAGES.DELIVERY_TODAY,
  DELIVERY_PARTIAL_2_MAN_FROM_TOMORROW: DELIVERY_MESSAGES.DELIVERY_TOMORROW,
  DELIVERY_PARTIAL_2_MAN_WITHIN_X_DAYS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_PARTIAL_2_MAN_WITHIN_X_WEEKS: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  DELIVERY_PARTIAL_2_MAN_FLEET_NEXT_DAY_OVERRIDE: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,

  DELIVERY_OUT_OF_STOCK: ERROR_MESSAGES.OUT_OF_STOCK,
  DELIVERY_OUT_OF_STOCK_TU: ERROR_MESSAGES.OUT_OF_STOCK,
  DELIVERY_NOT_AVAILABLE: ERROR_MESSAGES.UNAVAILABLE,
  DELIVERY_NOT_AVAILABLE_AT: ERROR_MESSAGES.UNAVAILABLE
}

const FEATURE_TYPE_MAPPINGS = {
  // Exclusively available in store
  FT_6_DELIVERY: ERROR_MESSAGES.UNAVAILABLE,
  FT_6_COLLECTION: ERROR_MESSAGES.UNAVAILABLE,

  // Take back
  FT_10_DELIVERY: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  FT_10_COLLECTION: COLLECTION_MESSAGES.COLLECTION_AVAILABLE,

  // Pre-order
  FT_19_DELIVERY: DELIVERY_MESSAGES.DELIVERY_AVAILABLE,
  FT_19_COLLECTION: COLLECTION_MESSAGES.COLLECTION_AVAILABLE,

  // Coming soon
  FT_23_DELIVERY: ERROR_MESSAGES.UNAVAILABLE,
  FT_23_COLLECTION: ERROR_MESSAGES.UNAVAILABLE,

  // Not available online
  FT_27_DELIVERY: ERROR_MESSAGES.UNAVAILABLE,
  FT_27_COLLECTION: ERROR_MESSAGES.UNAVAILABLE,

  // No longer available
  FT_28_DELIVERY: ERROR_MESSAGES.UNAVAILABLE,
  FT_28_COLLECTION: ERROR_MESSAGES.UNAVAILABLE,

  // Currently unavailable (too popular)
  FT_29_DELIVERY: ERROR_MESSAGES.UNAVAILABLE,
  FT_29_COLLECTION: ERROR_MESSAGES.UNAVAILABLE,

  // Digital download (email within two hours)
  FT_30_COLLECTION: DELIVERY_MESSAGES.DELIVERY_TODAY,
  FT_30_DELIVERY: DELIVERY_MESSAGES.DELIVERY_TODAY
}

export const SHORT_AVAILABILITY_MESSAGING = {
  ...COLLECTION_MAPPINGS,
  ...DELIVERY_MAPPINGS,
  ...FEATURE_TYPE_MAPPINGS,
  UNAVAILABLE: ERROR_MESSAGES.UNAVAILABLE
}
